// import Monogram from "@/components/ui/icons/monogram";
// import { zoomOut } from "@/utils/motion/zoom-out";
// import useScrollLock from "@/utils/use-scroll-lock";
// import cn from "classnames";
// import { useUI } from "@/contexts/ui.context";
// import Partners from "@/components/pages/home/partners";
// import ChalkTv from "@/components/pages/home/chalk-tv";
// import News from "@/components/pages/about/news";
// import RelatedPosts from "@/components/pages/blog/related-posts";
//import { HOME_TEXT_QUERY } from "@/framework/queries/homeText";
// import { slideUp } from "@/utils/motion/slide-up";
// import { AnimatePresence, m } from "framer-motion";

import dynamic from "next/dynamic";
import About from "@/components/pages/home/about";
import Banner from "@/components/pages/home/banner";
import { getUrqlClient } from "@/lib/urql-client";
import { sanitize } from "@/framework/utils/sanitize";
import { QUERY_ALL_CLIENTS } from "@/framework/queries/clients";
import { QUERY_ALL_HOME_SLIDER } from "@/framework/queries/home-slider";
import { QUERY_ENDPOINTS } from "@/framework/utils/query-endpoints";
import { HEADER_AND_TEXT_QUERY } from "@/framework/queries/header_and_text";
import Seo from "@/utils/seo";
import News from "@/components/pages/about/news";
import { useEffect, useState } from "react";

const Partners = dynamic(() => import("@/components/pages/home/partners"), { ssr: false });
const ChalkTv = dynamic(() => import("@/components/pages/home/chalk-tv"), { ssr: false });
const seo = {
    slug: "",
    metaTitle: "Interior Designing Firm | Interior Design Studio",
    metaDescription:
      "Chalk Studio, an interior designing firm provides customized interior design solutions for residential & commercial spaces.",
  };

export default function Home({ clients, slider, press, homeText }) {
    const [isScrolled, setIsScrolled] = useState(false);
    useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(true);
    };

    const resetScrollState = () => {
      setIsScrolled(false);
    };

    // Attach scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup: Remove scroll event listener on unmount
    return () => {
      resetScrollState(); // Reset state when component unmounts (e.g., navigate to another page)
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
    return (
        <>
        <Seo seo={seo} />
            {/* <AnimatePresence mode="sync"> */}
            {/* <m.div
                        initial="from"
                        // whileInView={!loader ? "to" : "from"}
                        whileInView={ "to" }
                        viewport={{ once: true }}
                        variants={slideUp()}
                        id="mainContent"
                    > */}
            <Banner data={slider} />
            <About homeText={homeText} />
            {isScrolled && (
            <>
            <News press={press} title="Press & Media" />
            <Partners clients={clients} />
            <ChalkTv />
            </>
            )}
            {/* </m.div> */}
            {/* </AnimatePresence> */}
        </>
    );
}

// export async function getStaticProps({ params }) {
//     const client = await getUrqlClient();
//     let press = null;
//     let clients = null;
//     let homeText = null;
//     let slider = null;
//     try {
//         const pressResponse = await client.query(
//             QUERY_ENDPOINTS.QUERY_ALL_PRESS,
//             {
//                 start: 0,
//                 limit: 50,
//                 sortBy: ["id:asc"],
//                 filter: {},
//             },
//             { requestPolicy: "network-only" }
//         );
//         const sliderResponse = await client.query(QUERY_ALL_HOME_SLIDER, {
//             requestPolicy: "network-only",
//         });

//         const clientResponse = await client.query(
//             QUERY_ALL_CLIENTS,
//             {
//                 start: 0,
//                 limit: 50,
//                 sort: ["order:asc"],
//                 filters: {},
//             },
//             {
//                 requestPolicy: "network-only",
//             }
//         );

//         /* const homeTextResponse = await client.query(HOME_TEXT_QUERY, {
//           requestPolicy: "network-only",
//       });*/

//         //const homeTextResponse = await client.query(HOME_TEXT_QUERY, {}, { requestPolicy: "cache-and-network" });

//         const homeTextResponse = await client.query(
//             HEADER_AND_TEXT_QUERY,
//             {
//                 start: 0,
//                 limit: 1,
//                 sort: ["order:asc"],
//                 filters: {
//                     for: { eq: "Home" },
//                     order: { eq: 1 }
//                 },
//             },
//             {
//                 requestPolicy: "cache-and-network",
//             }
//         );


//         clients = clientResponse.data?.clients?.data.map((row) => sanitize(row)) || [];
//         slider = sliderResponse?.data?.homeSlider?.data?.attributes?.Projects || [];
//         press = pressResponse.data?.presses?.data.map((row) => sanitize(row)) || [];
//         //homeText=homeTextResponse?.data?.headerAndText?.data?.attributes || [];
//         homeText = homeTextResponse?.data?.headerAndTexts?.data?.[0]?.attributes || {};//Single Records
//     } catch (err) {
//         console.log(err);
//     }
//     return {
//         props: {
//             press: press ?? {},
//             clients: clients ?? {},
//             slider: slider ?? {},
//             homeText: homeText ?? {},
//         },
//         revalidate: 10, // In seconds
//     };
// }

export async function getStaticProps() {
    const client = await getUrqlClient();
    let press = [];
    let clients = [];
    let homeText = {};
    let slider = [];

    try {
        // Fetch only required fields for each query to reduce payload size.
        const [pressResponse, sliderResponse, clientResponse, homeTextResponse] = await Promise.all([
            client.query(QUERY_ENDPOINTS.QUERY_ALL_PRESS, {
                start: 0,
                limit: 10, // Limit to fewer items if possible
                sortBy: ["id:asc"],
                filter: {}, // Ensure only required fields are fetched
            }, { requestPolicy: "network-only" }),

            client.query(QUERY_ALL_HOME_SLIDER, { requestPolicy: "network-only" }),

            client.query(QUERY_ALL_CLIENTS, {
                start: 0,
                limit: 40, // Limit to fewer items if possible
                sort: ["order:asc"],
                filters: {}, // Ensure only required fields are fetched
            }, { requestPolicy: "network-only" }),

            client.query(HEADER_AND_TEXT_QUERY, {
                start: 0,
                limit: 1, // Only need the first result
                sort: ["order:asc"],
                filters: {
                    for: { eq: "Home" },
                    order: { eq: 1 },
                },
            }, { requestPolicy: "cache-and-network" }),
        ]);

        // Map and sanitize responses only if needed
        press = pressResponse.data?.presses?.data.slice(0, 10).map(sanitize) || []; // Use fewer records
        slider = sliderResponse?.data?.homeSlider?.data?.attributes?.Projects || [];
        clients = clientResponse.data?.clients?.data.slice(0, 10).map(sanitize) || []; // Use fewer records
        homeText = homeTextResponse?.data?.headerAndTexts?.data?.[0]?.attributes || {};
    } catch (err) {
        console.error("Error fetching data:", err);
    }

    return {
        props: {
            press,
            clients,
            slider,
            homeText,
        },
        revalidate: 604800, // 7 days in seconds rebuild automatically
    };
}


// export async function getServerSideProps(context) {
//     const client = await getUrqlClient();
//     let press = null;
//     let clients = null;
//     let homeText = null;
//     let slider = null;

//     try {
//         // Fetch Press Data
//         const pressResponse = await client.query(
//             QUERY_ENDPOINTS.QUERY_ALL_PRESS,
//             {
//                 start: 0,
//                 limit: 50,
//                 sortBy: ["id:asc"],
//                 filter: {},
//             },
//             { requestPolicy: "network-only" }
//         );

//         // Fetch Slider Data
//         const sliderResponse = await client.query(QUERY_ALL_HOME_SLIDER, {
//             requestPolicy: "network-only",
//         });

//         // Fetch Clients Data
//         const clientResponse = await client.query(
//             QUERY_ALL_CLIENTS,
//             {
//                 start: 0,
//                 limit: 50,
//                 sort: ["order:asc"],
//                 filters: {},
//             },
//             { requestPolicy: "network-only" }
//         );

//         // Fetch Home Text Data
//         const homeTextResponse = await client.query(
//             HEADER_AND_TEXT_QUERY,
//             {
//                 start: 0,
//                 limit: 1,
//                 sort: ["order:asc"],
//                 filters: {
//                     for: { eq: "Home" },
//                     order: { eq: 1 },
//                 },
//             },
//             { requestPolicy: "cache-and-network" }
//         );

//         // Process Responses
//         clients = clientResponse.data?.clients?.data.map((row) => sanitize(row)) || [];
//         slider = sliderResponse?.data?.homeSlider?.data?.attributes?.Projects || [];
//         press = pressResponse.data?.presses?.data.map((row) => sanitize(row)) || [];
//         homeText = homeTextResponse?.data?.headerAndTexts?.data?.[0]?.attributes || {};
//     } catch (err) {
//         console.error("Error fetching data in getServerSideProps:", err);
//     }

//     return {
//         props: {
//             press: press ?? {},
//             clients: clients ?? {},
//             slider: slider ?? {},
//             homeText: homeText ?? {},
//         },
//     };
// }

